var MessageTcc = {
  NavabarText: {
    navbar_about: "關於我們",
    navbar_item: "基因檢測",
    navbar_search: "報告查詢",
    navbar_searchy: "母血篩查報告",
    navbar_searchys: "葉酸代謝基因測試報告",
    navbar_contact: "聯絡我們",
    navbar_newinformation: "最新消息",
    navbr_jiyin: '基因天地',
    banner_text_tip: "檢測服務與技術",

  },
  indexText: {
    more: "了解更多",

  },
  ContractText: {
    company_full_name: "香港卓信醫療化驗所有限公司",
    // company_address: "香港新界火炭禾盛街11號 中建電訊大廈8樓01室",

    company_address: "香港新界火炭坳背灣街2-12號威力工業中心9樓S室",
    address: "地址",
    tel: "電話",
    fax: "傳真",
    email: "郵箱",
    web: "網址",

    quickContactYou: '我們的客服代表將盡快與您聯繫',
    namemust: '姓名 (必須)',
    phonemust: '電話 (必須)',
    emailmust: '電郵 (必須)',
    topic: '主题',
    content: '留言',

    mailbox_title: "咨詢信箱",
    mailbox_subtitle: "【點擊申請加盟】",
    mailbox_type: "咨詢類型",
    mailbox_type_1: "顧客咨詢",
    mailbox_type_2: "合作咨詢",
    mailbox_sex_mr: "先生",
    mailbox_sex_mrs: "女士",
    mailbox_sex_lady: "夫人",
    mailbox_surname: "姓氏",
    mailbox_tel_phone: "聯系電話：",
    mailbox_email: "電子信箱：",
    mailbox_message: "留言內容：",
    mailbox_btn: "確 認",


    code: "證件號碼",
    labno: "樣本編號",
    name: "受測者姓名",
    phone: "電話號碼",
    vertify: "驗   證   碼",
    vertifys: "驗證碼",
    send_sms: "發送驗證碼",
    send_sms_second: '再次發送',

    vertify_placeholder: "請輸入驗證碼",
    phone_placeholder: "請輸入手機號",
    tech_title: '我們的合作伙伴',
    medical: '醫療機構',
    physical: '體檢中心',
    individual: '個人',
    organization: '非盈利機構',
    doctor: '醫生',
    warning: '本人已閱讀及同意網站的',
    private:'私隱政策',
    speaker: '語音驗證',
    report_search_description: '母血篩查報告查詢指引：',
    description_one: '報告查詢功能於化驗所發送報告後的第二天 12:00 提供。',
    description_two: '請確保您輸入的受測者名字及樣本編號與收到的報告一致。',
    description_three: '根據指引輸入手機號碼，點擊“發送驗證碼”，您將收到 5 位數字的短信驗證碼。',
    description_four: '輸入短信驗證碼，點擊“確認”，您將成功查詢到報告。',
    description_five: '若未收到短信驗證碼，請嘗試“語音驗證”。',
    report_search_descriptionys: '葉酸代謝基因測試報告查詢指引：',
    description_oneys: '報告查詢功能於化驗所發送報告後的第二天 12:00 提供。',
    description_twoys: '請確保您輸入的受測者名字及樣本編號與收到的報告一致。',
    description_threeys: '根據指引輸入手機號碼，點擊“發送驗證碼”，您將收到 5 位數字的短信驗證碼。',
    description_fourys: '輸入短信驗證碼，點擊“確認”，您將成功查詢到報告。',
    description_fiveys: '若未收到短信驗證碼，請嘗試“語音驗證”。',
    verson: "版權所有",
    termsofuse: '使用條款',
    privacypolicy: '私隱政策',
    addressfoot: '香港新界火炭坳背灣街2-12號威力工業中心9樓S室',
    newinfo: '最新消息',
    GeneUniverse: '基因天地',
    ContactUs: '聯絡我們',
    servicetime: '營業時間',
    TestingService: '檢測服務',
    CompanyName: '香港卓信醫療化驗所',
    weeks: '星期一至五',
    saturday: '星期六',
    holidays: '星期日及公眾假期 休息',
    Y_chromosome: 'Y-染色體母血篩選',
    PrenatalTesting: '無創產前檢測',
    stdfastces: '癌症實時監控',
    CancerReal: '癌症實時監控',
    Prenatal_Paternity_Testing: '無創產前親子鑑定',
    genetic_tumor: '遺傳性腫瘤檢測',
    genetesting: '天賦基因檢測',
    Thalassemia: '地中海貧血基因檢測',
    Detection_diseases: '單基因遺傳病檢測',
    Vaccine: '疫苗抗體檢測',
    aboutzhouxin: '關於卓信',
    aboutus: '關於我們',
    technology: '科研技術',
    qualification: '資質及殊榮',
    mediacenter: '媒體中心',
    cooperation: '合作',
    recruitment: '人才招募',
    reproductivehealth: '生育健康',
    Y_chromosome_maternal_blood: 'Y-染色體母血篩選',
    mthfr: '葉酸代謝基因檢測',
    Noninvasiveprenataltesting: '無創產前檢測',
    Noninvasive_prenatal_paternity_test: '無創產前親子鑑定',
    Paternity_testing: '親子鑑定',
    Fragile_X_syndrome_screening: '脆性X綜合症篩查',
    Detection_of_monogenic_genetic_diseases: '單基因遺傳病檢測',
    cancer: '癌症',
    Genetic_tumor_detection: '遺傳性腫瘤檢測',
    Cancer_real_time_monitoring: '癌症實時監控',
    Infectious_diseases: '傳染病',
    Vaccine_antibody_test: '疫苗抗體檢測',
    STD_quick_test: '性病快速測試',
    Talent_gene_testing: '天賦基因檢測',
    Noninvasive_prenatal_testing: '無創產前檢測',
    Health_and_disease_risk: '健康與疾病風險',
    Yreport: '母血篩查報告',
    MTHFRreport: '葉酸代謝基因測試報告',


  },
  GensUniverseText: {
    gens_tip_1: '無免疫力孕婦的患麻疹 最嚴重可流產',
    gens_content_1: '本港今年年初發生的麻疹疫情非常嚴重，雖然現在情況可說是受到控制，但各界也不能掉以輕心。',

    gens_tip_2: '無入侵性抽血驗癌症 適宜年老病人',
    gens_content_2: '每當談到癌症檢驗，活組織抽檢往往令不少人卻步，不過現今醫學發展迅速，檢測癌症可用非入侵性方式，而且這項技術愈趨成熟，令風險及成本降低，讓更多人受惠。',

    gens_tip_3: '最易被忽略的一種過敏食物',
    gens_content_3: '好多家長都話小朋友有食物過敏，情況有幾普遍？大家對幼兒食物過敏的認知有多少？',

    gens_tip_4: '樂觀女性生仔機會較大',
    gens_content_4: '英國一項研究發現，性格樂觀和生活較輕鬆的女性，懷孕時生男孩的機會較大，建議想生男嬰的女性更要保持心境開朗及良好體格。',

    gens_tip_5: '雙胞胎兒竟然是同母異父',
    gens_content_5: '福建省廈門市一對夫妻因為要幫雙胞胎兒子報戶口，所以去做親子鑑定，沒想到結果顯示，雙胞胎竟是「同母異父」兄弟！',

    gens_tip_6: '研究證實NIPT檢測範圍擴展至染色體微片段缺失重複是臨床迫切的需求',
    gens_content_6: '隨著臨床數據的不斷累積和分析技術的精進，非侵入性產前檢測（NIPT）的臨床應用未來勢必更加廣泛，這也將會是孕婦與胎兒的一大福音。',

    gens_tip_7: '全方位癌症基因分析 突破無藥可治的困局',
    gens_content_7: '就某些癌症而言，如肺癌和乳癌，基因檢測的結果會直接影響治療方案，故醫生一般會在確診的同時建議患者進行基因檢測，把握時間，及早開始用「對」的藥。',

    gens_tip_8: '接種了問題疫苗 身體還會產生抗體嗎？',
    gens_content_8: '屢次發生的疫苗事件令父母們憂心重重，對疫苗的效力完全失去信心，不少家長就設法為小朋友檢測抗體，希望確定之前所注射的疫苗是有產生足夠抗體來保護小朋友。',

    gens_tip_9: '基因如何影響天賦潛能？',
    gens_content_9: '天賦基因檢測報告中判斷孩子相關天賦的依據是什麼？',

    gens_tip_10: '邵逸夫獎得獎科學家預計 中國女性患乳腺癌的風險將持續上升',
    gens_content_10: '乳癌是本港女性最常見的癌症。一位科學家就預計在中國及香港，患上乳腺癌的女性只會有增無減。',

    gens_tip_11: '消失中的唐氏綜合症 香港孕婦產檢與中止懷孕現況',
    gens_content_11: '唐氏綜合症在冰島可能因產前檢查與中止懷孕的關係消失，那在香港的情況又如何？',

    gens_tip_12: '追查遺傳基因 罕見疾病難隱身',
    gens_content_12: '遺傳病可經由基因一代傳一代，而遺傳學專家就如偵探一樣，可利用基因檢測等技術，在婚前檢查或產前檢查階段，盡力發掘潛藏的遺傳密碼，以減低病發率及相關併發症出現。',

    gens_tip_13: '中大完成二萬人「血漿DNA」鼻咽癌篩查研究 大幅推前癌症發現期數',
    gens_content_13: '香港中文大學最近完成一項涉及20,000人的研究，確定透過分析血漿內EB病毒DNA，便可在尚未有病徵前及早診斷出鼻咽癌。',
  },

  HomeText: {
  //   BannerTip_1_1: '6',
  //   BannerTip_1_2: '週',
  //   BannerTip_1_3: '即',
  //   BannerTip_1_4: '可',
  //   BannerTip_1_5: '檢',
  //   BannerTip_1_6: '測',
  //   BannerTip_1_Left: 'Y-染色體母血篩選',
  //   BannerTip_1_Right: '最快當日出結果',

    BannerTip_2_1: '基',
    BannerTip_2_2: '因',
    BannerTip_2_3: '角',
    BannerTip_2_4: '度',
    BannerTip_2_5: '度',
    BannerTip_2_6: '身',
    BannerTip_2_7: '打',
    BannerTip_2_8: '造',
    BannerTip_2_Left: '天賦基因檢測選',
    BannerTip_2_Right: '掌握天賦潜能',


    BannerTip_3: '榮獲ISO9001國際品質認證',
    BannerTip_3_Left: '香港卓信醫療化驗所',
    BannerTip_3_Right: '因為卓越.值得信賴',
    BannerTip_4:'榮獲「商界展關懷」殊榮',
    GeneticTests: "基因檢測",
    GeneticButton: "檢測項目",
    ReproductiveHealth: "為BB買衫、買鞋",
    ReproductiveHealth2: "更要給他買不到的健康",
    Cancer: "再早一點",
    Cancer2: "生命就再多一點可能性",
    InfectiousDisease: "保護自己",
    InfectiousDisease2: "也要保護你愛的人",
    HealthyLife: "瞭解更多人生故事",
    HealthyLife2: "開啟全新的生活方式",
    GeneticTestsSubtitleButton: "瞭解更多",
    GeneticTestsSubtitle1: "卓越科技 拯救生命",
    GeneticTestsSubtitle1Detail: "强大的團隊配搭全球領先的科技，",
    GeneticTestsSubtitle1Detail2: "讓人們透過基因，掌控自己的健康狀況。",
    GeneticTestsSubtitle2: "專業認可 值得信賴",
    GeneticTestsSubtitle2Detail: "作為香港持牌化驗所，",
    GeneticTestsSubtitle2Detail2: "獲得ISO國際認證，給客戶更多信心。",
    ServingLocalClinics: "服務本地診所",
    SamplesProcesses: "處理樣本數目",
    LatestGeneticInformation: "最新基因資訊",

  },

  AboutFCLAB: {
    Title: "關於卓信",
    FirstChoiceMedicalLaboratory: "香港卓信醫療化驗所",
    FirstChoiceMedicalLaboratoryDetail: "所謂「卓信」，因卓越而值得信賴。",
    FirstChoiceMedicalLaboratoryDetail2: "更高質素的基因檢測科技，更方便快捷的服務，是顧客的最佳選擇。",
    Mission: "企業使命",
    MissionDetail: "結合創新的思維、嶄新的基因檢測科技，為顧客提供最專業和最精准的檢測。",
    MissionDetail2: "開發和應用最新的遺傳和基因組科技，讓更多人意識到醫療保健的力量。",
    CoreCulture: "核心文化",
    Professional: "專業",
    ProfessionalDetail: "提供專業精准的DNA檢測服務，使顧客受惠",
    Honest: "誠信",
    HonestDetail: "採用誠信的態度與客戶溝通，建立彼此之間的信任",

  },

   // 新加FCLAB简介用于优化
   aboutFCLAB: {
    Title: "卓信化验所簡介",
    FirstChoiceMedicalLaboratory: "公司簡介",
    FirstChoiceMedicalLaboratoryDetail: "香港卓信醫療化驗所有限公司，2017年10月27日成立於香港，公司編號2598283,主要提供基因檢測服務。是香港少數獲得ISO認證的醫療化驗所。地址位於香港新界火炭坳背灣街2-12號威力工業中心9樓S室。 專業的一級醫務化驗師於香港醫務化驗師管理委員會註冊，監管樣本處理流程及簽發化驗報告。專注基因檢測，提供無創產前檢測、親子鑒定、單基因遺傳病、遺傳性腫瘤檢測、癌症即時監控、疫苗抗體檢測、首創的genecode天賦基因檢測等，受到客戶信賴。",
    
    Mission: "產品服務",
    MissionDetail: "香港卓信醫療化驗所有限公司專注基因檢測，主要提供以下4大類基因檢測 ",
    MissionDetail2: "生育健康",
    MissionDetail3: "無創產前檢測、無創產前親子鑒定、親子鑒定、單基因遺傳病等  ",
    MissionDetail4: "癌症",
    MissionDetail5: "遺傳性腫瘤檢測、癌症即時監控等 ",
    MissionDetail6: "傳染病",
    MissionDetail7: "疫苗抗體檢測，性病快速測試等 ",
    MissionDetail8: "天賦基因檢測",
    MissionDetail9: "首創genecode天賦基因檢測 ",
    MissionDetail10: "葉酸代謝基因檢測",
    MissionDetail11: "通過對MTHFR基因其相關位元點的檢測，根據個人情況選擇葉酸補充途徑。(檢測需時：1個工作日，支持網上查報告)",
    MissionDetail12: "公司理念",
    MissionDetail13: "因為卓越，所以值得信賴。",
    MissionDetail14: "更高質素的基因檢測科技，更方便快捷的服務，成為顧客的最佳選擇。    ",
    MissionDetail15: "公司使命",
    MissionDetail16: "結合創新的思維、嶄新的基因檢測科技，為顧客提供最專業和最精准的檢測。",
    MissionDetail17: "開發和應用最新的遺傳和基因組科技，讓更多人意識到醫療保健的力量。",
    MissionDetail18: "發展歷程",
    MissionDetail19: "2017年10月27日，香港卓信醫療化驗所有限公司註冊成立。  ",
    MissionDetail20: "香港卓信醫療化驗所有限公司是一間專業的醫療化驗所，專注基因檢測及普及基因檢測的應用，尤其生育及親子健康方面。 ",
    MissionDetail21: "2018年，香港卓信醫療化驗所成功通過BSI英國標準協會的審核，榮獲ISO 9001:2015國際品質認證。",
    MissionDetail22: "於2020/21年獲香港社會服務聯會頒發“商界展關懷”殊榮。",
    MissionDetail23: "2019年，香港卓信醫療化驗所有限公司成功自創品牌genecode，為顧客帶來更全面、更準確的天賦基因檢測。 ",
    MissionDetail24: "公司地址",
    MissionDetail25: "香港新界火炭坳背灣街2-12號威力工業中心9樓S室",
  },
  Technology: {

    Title: "科研科技",

    P1Title: "我們深明檢測準確的重要性",

    P1Detail: "每項檢測均為專業團隊的成果",


    P2_1Title: "博士及碩士級科學家",

    P2_1Detail: "利用當代最新科技，研發及驗證合乎國際標準的基因測試",

    P2_2Title: "注册一級醫務化驗師",

    P2_2Detail: "於香港醫務化驗師管理委員會注册，監管樣本處理流程及簽發化驗報告",

    P2_3Title: "醫生顧問",

    P2_3Detail: "根據現有的臨床醫學研究，提供有關資訊和意見",


    P3Title: "採用全球先進的DNA檢測儀器分析每個樣本",

    P3Detail: "檢測試劑均由國外進口，受嚴格的品質監控",


    P4Title: "與國際知名化驗所緊密合作",

    P4_1Detail: "梅奧醫學實驗室",

    P4_2Detail: "Natera",

    P4_3Detail: "路勝基因",

  },

  Accreditation: {
    Title: "資質及殊榮",
    P1Title: "香港認可的持牌化驗所",
    P1Detail: "受香港醫務化驗師管理委員會嚴格監管",
    P1Button: "查看名單",

    P2Title: "香港少數獲ISO認證化驗所",
    P2Detail: "香港卓信醫療化驗所成功通過BSI英國標準協會的審核，榮獲ISO 9001:2015國際品質認證，標誌著香港卓信醫療化驗所在品質管理方面達到更高的水准，令您使用的服務得到國際水準的保證。",
    P2Detail2: "香港卓信醫療化驗所一直努力建立一套專業化、標準化、制度化，並且符合國際標準的品質管理系統，好讓客戶得到最優質的醫療化驗服務。本化驗所獲頒的ISO 9001:2015品質管理證書，正好印證了我們致力提供高質素服務的决心。",

    P3Title: "關於ISO 9001",
    P3Title2: "國際標準組織| International Organization for Standardization（ISO）",
    P3Detail: "ISO 9001是一套國際通用的品質管理工具，標準由專家群在技術委員會內制訂，用以維持企業提供之產品與服務的品質，確保品質一致性技術。委員會由工業界、非政府組織、政府和其他利益相關者的代表組成，成員由ISO成員提出。獲得ISO 9001認證代表機構或組織通過嚴格的企業體系審核，達到國際認可的標準。",
    P3Detail2: "全新改版的ISO 9001:2015引入了風險思維的理念，加强關注公司的營運風險，同時考慮了當今不斷變化的外圍環境，以及協助公司應對客戶日新月异的要求，提升企業競爭力。",

    P4Title: "榮獲「商界展關懷」殊榮",
    P4Detail: "香港卓信醫療化驗所實踐良好企業公民精神，於2020/21年獲香港社會服務聯會頒發「商界展關懷」殊榮。我們會持續參與社會服務，為改善社會、改善環境繼續努力。",
    
    P5Title: "綠色辦公室獎勵計劃",
    P5Detail: "作為一家對社會有承擔的企業，我們在實驗室範圍內進行改善工程，從日常工作流程至個人生活習慣入手，減少對環境造成影響，積極實踐可持續發展的理念，並承諾繼續為社會作出貢獻。",
  },

  Media: {
    Title: "媒體中心",
    P1Title: "精准的基因檢測 x 專業的醫療服務",
    P1_1Detail: "堅守品牌價值",
    P1_1Detail2: "報告嚴謹可信",
    P1_1Button: "報告査詢",

    P1_2Detail: "匯集權威檢測",
    P1_2Detail2: "行業領先資訊",
    P1_2Button: "基因天地",

    P1_3Detail: "綠色工作環境",
    P1_3Detail2: "承擔企業責任",
    P1_3Button: "獲獎證書",


    P1_4Detail: "配備先進儀器",
    P1_4Detail2: "資深科技人才",
    P1_4Button: "科研科技",

    P1_5Detail: "樣本成千上萬",
    P1_5Detail2: "嚴格監控品質",
    P1_5Button: "認證資質",

    P1_6Detail: "洞察商業脈搏",
    P1_6Detail2: "誠邀多方合作",
    P1_6Button: "合作",

  },

  Partnership: {
    Title: "合作",
    P1Title: "由於醫務化驗師《專業守則》第II章第6（c）節規定：",
    P1Detail: "醫務化驗師均不得在未有來自注册醫生、牙醫和／或獸醫或根據香港法例第343章診療所條例第8（1）條豁免診療所注册人士的轉介情况下，進行為醫務診斷或治療的任何化驗。",
    P1Detail2: "香港卓信醫療化驗所僅接受來自診所醫生轉介的樣本。如有關化驗所的任何問題，歡迎來電（+852）2865 9399諮詢。",
  },

  Career: {
    Title: "人才招募",
    P1Title: "有意投身醫療化驗行業？",
    P1Title2: "職責：",
    P1Title3: "資歷：：",
    P2Detail: "如欲申請上述空缺，請將履歷電郵至hr@hkfirstchoice.com",
    P2Detail2: "（請注明申請職位）",
  },

  Cancerrealtime: {
    CancerReal_one: '及早發現癌症復發．掌握治療黃金期',
    CancerReal_two: '以嶄新ctDNA技術．隨時掌握腫瘤動向',
    CancerReal_three: '什麼是循環腫瘤DNA（ctDNA）？',
    CancerReal_four: '循環腫瘤DNA（Circulating Tumor DNA, ctDNA）是癌細胞壞死或凋亡後釋放至血液中的DNA片段，帶有重要的癌症基因變異資訊。',
    CancerReal_five: '藉由監控ctDNA在血液中的動態變化，能夠反應患者體內腫瘤的狀況，及早偵測到癌症復發跡象。',
    CancerReal_six: '比傳統方式更早偵出復發',
    CancerReal_seven: 'LiquidHALLMARK',
    CancerReal_f: ' 癌症实时监控',
    CancerReal_eight: '全球首個利用ctDNA技術，同時檢測致癌基因突變和致癌病毒的血液測試',
    CancerReal_nine: '由AmpliMARK™專利技術支持，可以檢測極微量的ctDNA。',
    CancerReal_ten: '通過臨床驗證，為腫瘤科醫生提供癌症治療新方向。',
    CancerReal_eleven: '50種癌症基因',
    CancerReal_twelve: '包括多種標靶藥相關基因，如EGFR（吉非替尼、奧希替尼）及ALK（克唑替尼）',
    CancerReal_threeteen: '6個微衛星不穩定性位點',
    CancerReal_fourteen: '決定可否選用免疫治療',
    CancerReal_fiveteen: '2種致癌病毒',
    CancerReal_sixteen: '乙型肝炎病毒（HBV）及艾巴氏病毒（EBV）',
    CancerReal_seventeen: '4種基因變異',
    CancerReal_eighteen: '點突變、小型插入/缺失、基因擴增、基因融合',
    CancerReal_nineteen: '一次抽血監測14種癌症',
    CancerReal_twenty: '肺癌',
    CancerReal_twenty_one: '12種 癌症基因',
    CancerReal_twenty_two: '乳癌',
    CancerReal_twenty_three: '9種 癌症基因',
    CancerReal_twenty_four: '大腸癌',
    CancerReal_twenty_five: '11種 癌症基因',
    CancerReal_twenty_six: '肝癌',
    CancerReal_twenty_seven: '14種 癌症基因 +HBV病毒',
    CancerReal_twenty_eight: '鼻咽癌',
    CancerReal_twenty_nine: '7種 癌症基因 +EBV病毒',
    CancerReal_thirty: '膽管癌',
    CancerReal_thirty_one: '19種 癌症基因',
    CancerReal_thirty_two: '食道癌',
    CancerReal_thirty_three: '13種 癌症基因',
    CancerReal_thirty_four: '胃腸道間質瘤',
    CancerReal_thirty_five: '7種 癌症基因',
    CancerReal_thirty_six: '血癌（包括骨髓瘤）',
    CancerReal_thirty_eight: '10種 癌症基因',
    CancerReal_thirty_nine: '頭頸部鱗狀癌',
    CancerReal_fourty: '8種 癌症基因',
    CancerReal_fourty_one: '黑色素瘤',
    CancerReal_fourty_two: '14種 癌症基因',
    CancerReal_fourty_four: '胰臟癌',
    CancerReal_fourty_five: '8種 癌症基因',
    CancerReal_fourty_six: '泌尿上皮癌',
    CancerReal_fourty_seven: '8種 癌症基因',
    CancerReal_fourty_eight: '前列腺癌',
    CancerReal_fourty_nine: '6種 癌症基因',
    CancerReal_fifty: 'LiquidMARK',
    CancerReal_fifty_one: ' 可選擇個別癌症定期監察。',
    CancerReal_fifty_two: '以上檢測均包含6個微衛星不穩定性（MSI）位點。',
    CancerReal_fifty_three: 'LiquidHALLMARK',
    CancerReal_fuhao: '®',
    CancerReal_canhelp: ' 可幫您',
    CancerReal_fifty_four: '提供用藥指導',
    CancerReal_fifty_five: '由於年老或腫瘤位置特殊等原因，部分癌症患者無法抽取腫瘤組織',
    CancerReal_fifty_six: 'ctDNA可幫助無法以手術或穿刺取得腫瘤組織的患者 提供用藥指導建議。',
    CancerReal_fifty_seven: '評估治療效果',
    CancerReal_fifty_eight: '研究表明，癌症患者給予適當的治療後，如有良好治療效果，則偵測到的ctDNA量會明顯下降',
    CancerReal_fifty_nine: '手術後在血液中檢測不到ctDNA，患者預後較佳。',
    CancerReal_sixty: '檢測到ctDNA，預後相對較差，有更大機會復發。',
    CancerReal_sixty_one: '監控癌症復發',
    CancerReal_sixty_two: '研究表明，ctDNA的變化較影像檢測早5.2個月發現癌症復發跡象',
    CancerReal_sixty_three: 'ctDNA可早期偵測到復發跡象，因此可藉由後續密集監控，幫助病人及早制定癌症治療方案。',
    CancerReal_sixty_four: '追蹤抗藥性',
    CancerReal_sixty_five: '癌症病人使用某種藥物一段時間後失效，其原因可能是來自於特定基因位點突變而導致抗藥性',
    CancerReal_sixty_six: '利用ctDNA突變位點的偵測，可及早發現抗藥性突變，調整適合的藥物治療策略',
    CancerReal_sixty_seven: '適用人群',
    CancerReal_sixty_eight: '常見問題',
    CancerReal_sixty_nine: 'LiquidHALLMARK',
    CancerReal_sixty_nine_end: ' 適用於健康人群的癌症早期篩查嗎？',
    CancerReal_seventy: '不適用。本檢測適用於已確診癌症的患者，用於實時監控腫瘤動向，及早瞭解癌症復發跡象。',
    CancerReal_seventy_one: '我是否需要進行多次檢測？',
    CancerReal_seventy_two: '本檢測可提供密切關注，建議每6-12個月定期檢測。您所需的具體檢測次數取決於您的疾病階段和治療效果，由您的主診醫生判斷。',
    CancerReal_seventy_three: '檢測微衛星不穩定性（MSI）的意義何在？',
    CancerReal_seventy_four: '微衛星不穩定性（MSI）可用於預測免疫治療的效果，幫助患者判斷是否適合免疫治療，避免花費高額治療費用或錯過治療黃金期。',
    CancerReal_seventy_five: '參考文獻',

  },

  Genetictumordetection: {
    Genetictumordetection_one: '癌症基因可遺傳',
    Genetictumordetection_two: '高風險人群及早檢測．預防勝於治療',
    Genetictumordetection_three: '遺傳性腫瘤基因變異會大幅增加罹癌風險',
    Genetictumordetection_four: '據統計，每年全球患癌新症數字約有1,750萬，當中死亡人數高達870萬。而癌症患者中，約5-10%是由遺傳性基因變異引起的。如常見的BRCA1/2基因突變會使乳癌、卵巢癌1,2、大腸癌3及胃癌4等罹患風險大幅提高。',
    Genetictumordetection_five: '註冊化驗室簽發報告',
    Genetictumordetection_fives:'您的家人曾罹癌癌症嗎？',
    Genetictumordetection_six: '您曾經早於50歲罹患原位癌嗎？',
    Genetictumordetection_seven: 'FCRisk™ 遺傳性腫瘤基因檢測',
    Genetictumordetection_eight: '提供詳盡的基因資訊，可幫助醫生評估相關癌症的罹患風險。',
    Genetictumordetection_nine: '為檢測者日後的治療與健康管理提供依據，讓高風險人群可及早採取預防性措施。',
    Genetictumordetection_ten: '為不同性別提供兩種套餐，男士套餐檢測79個基因，合共評估16種遺傳性腫瘤；女士套餐檢測74個基因，合共評估17種遺傳性腫瘤。',
    Genetictumordetection_eleven: '男士套餐',
    Genetictumordetection_twelve: '遺傳性腫瘤',
    Genetictumordetection_threeteen: '女士套餐',
    Genetictumordetection_fourteen: '前列腺癌  ',
    Genetictumordetection_fiveteen: '乳腺癌',
    Genetictumordetection_sixteen: '卵巢癌',
    Genetictumordetection_seventeen: '子宮內膜癌',
    Genetictumordetection_eighteen: '大腸癌 ',
    Genetictumordetection_nineteen: '胃癌',
    Genetictumordetection_twenty: '腎癌',
    Genetictumordetection_twenty_one: '多發性內分泌腺瘤',
    Genetictumordetection_twenty_two: '甲狀腺癌',
    Genetictumordetection_twenty_three: '甲狀腺旁腺癌',
    Genetictumordetection_twenty_four: '多發性神經纖維瘤 ',
    Genetictumordetection_twenty_five: '嗜鉻細胞瘤',
    Genetictumordetection_twenty_six: '家族性副神經節瘤',
    Genetictumordetection_twenty_seven: '視網膜母細胞瘤',
    Genetictumordetection_twenty_eight: '黑色素瘤',
    Genetictumordetection_twenty_nine: '多發性軟骨肉瘤',
    Genetictumordetection_thirty: '胰腺癌',
    Genetictumordetection_thirty_one: '胃腸道間質瘤癌',
    Genetictumordetection_thirty_two: '適用人群',
    Genetictumordetection_thirty_three: '具癌症家族史的高風險人群',
    Genetictumordetection_thirty_four: '具癌症家族史的罹癌患者',
    Genetictumordetection_thirty_five: '罹患兩種以上原位癌且發病年齡早於50歲，但沒有家族史的罹癌患者',
    Genetictumordetection_thirty_six: '擔憂自己攜帶遺傳性腫瘤基因突變的健康人群',
    Genetictumordetection_thirty_eight: '檢測優勢',
    Genetictumordetection_thirty_nine: '全面篩查',
    Genetictumordetection_fourty: '一次檢測，終身受用',
    Genetictumordetection_fourty_one: '精準穩妥',
    Genetictumordetection_fourty_two: '測序準確率高達99.9%，大型數據庫支持',
    Genetictumordetection_fourty_three: '專屬建議',
    Genetictumordetection_fourty_four: '由專業的遺傳咨詢顧問進行報告解讀',
    Genetictumordetection_fourty_five: '安全可靠',
    Genetictumordetection_fourty_six: '簡單抽血即可， 對受測者傷害減至最低',
    Genetictumordetection_fourty_seven: '檢測流程',
    Genetictumordetection_fourty_eight: '1. 檢測前咨詢',
    Genetictumordetection_fourty_nine: '選擇適合自己的檢測套餐',
    Genetictumordetection_fifty: '2. 採集樣本',
    Genetictumordetection_fifty_one: '診所抽血並將樣本送至化驗所檢測',
    Genetictumordetection_fifty_two: '3. 基因測序分析',
    Genetictumordetection_fifty_three: '以嚴謹的實驗流程完成測序及分析',
    Genetictumordetection_fifty_four: '4. 簽發報告',
    Genetictumordetection_fifty_five: '由註冊一級化驗師簽發',
    Genetictumordetection_fifty_six: '5. 解讀報告',
    Genetictumordetection_fifty_seven: '對報告解讀並進行健康風險管理',
    Genetictumordetection_fifty_eight: '參考文獻',
    Genetictumordetection_fifty_nine: '據統計，每年全球',
    Genetictumordetection_sixty: '患癌新症數字約有1,750萬',
    Genetictumordetection_sixty_one: ',當中死亡人數高達870萬。而癌症患者中，',
    Genetictumordetection_sixty_two: '約5-10%是由遺傳性基因變異引起的。',
    Genetictumordetection_sixty_three: '如常見的BRCA1/2基因突變會使乳癌、卵巢癌',
    Genetictumordetection_sixty_four: '、大腸癌',
    Genetictumordetection_sixty_five: '及胃癌',
    Genetictumordetection_sixty_six: '等罹患風險大幅提高。',

  },

  Talentgenetesting: {
    Talentgenetesting_one: '掌握天賦潛能・達致因材施教',
    Talentgenetesting_two: '基因角度分析特質・度身打造培育建議',
    Talentgenetesting_three: '基因密碼千差萬別，讓我們生而不同',
    Talentgenetesting_four: '子女是上天賜予父母的禮物，每位小朋友都是獨一無二的。',
    Talentgenetesting_five: '遺傳學上，人與人之間的不同是由基因決定的。最常見的是由單個核苷酸改變而引起的DNA序列的改變，即單核苷酸多態性（Single Nucleotide Polymorphism，簡稱SNP）。',
    Talentgenetesting_six: '除了如瞳孔顏色等外觀表型，我們的天賦潛能、性格發展、智商高低、營養代謝需求等內在情況，某程度上都是由SNP決定的。',
    Talentgenetesting_seven: '如何預測小朋友的天賦潛能？',
    Talentgenetesting_eight: '隨著人類基因組測序計劃的完成，基因芯片及第二代測序技術的成熟，已經可以讓我們解析這些基因密碼。',
    Talentgenetesting_nine: '通過大規模的全基因組關聯分析研究（Genome-wide association study, GWAS），找出與天賦相關的SNP基因位點。',
    Talentgenetesting_ten: 'genecode天賦基因檢測',
    Talentgenetesting_eleven: '以基因組學為本的超全面天賦基因測試',
    Talentgenetesting_twelve: '涵蓋天賦，智商，情商，營養健康及健身五大範疇',
    Talentgenetesting_threeteen: '第二代測序技術，基因分型準確率達99.9％',
    Talentgenetesting_fourteen: '集合7大基因組數據庫，專注亞洲人數據',
    Talentgenetesting_fiveteen: '非侵入性採樣，安全無痛，簡單快捷',
    Talentgenetesting_sixteen: '檢測詳情',
    Talentgenetesting_seventeen: '5大成長因素（70個項目）自由組合',
    Talentgenetesting_eighteen: '天資密碼（Talent Code）– 6項',
    Talentgenetesting_nineteen: '6種天賦潛能：語言天賦、音樂天賦、數學天賦、閱讀天賦、繪畫天賦、運動天賦',
    Talentgenetesting_twenty: '情商密碼（EQ Code）– 14項',
    Talentgenetesting_twenty_one: '5種性格：多情性格、內向性格、衝動性格、隨和性格、高度敏感性格',
    Talentgenetesting_twenty_two: '4種能力：堅持力、注意力、領導力、抗壓力',
    Talentgenetesting_twenty_three: '3種心向：責任心、好奇心、同理心 ',
    Talentgenetesting_twenty_four: '2種傾向：焦慮傾向、獎勵依賴',
    Talentgenetesting_twenty_five: '智商密碼（IQ Code）– 14項 ',
    Talentgenetesting_twenty_six: '8項記憶力：邏輯記憶力、視覺記憶力、空間記憶力、長期記憶力、短期記憶力、工作記憶力、情景記憶力、語音記憶力',
    Talentgenetesting_twenty_seven: '3項智商：晶體智商、流體智商、操作智商',
    Talentgenetesting_twenty_eight: '3項能力：避錯能力、認知能力、推理能力',
    Talentgenetesting_twenty_nine: '營養與健康密碼（Nutrition & Health Code）– 26項',
    Talentgenetesting_thirty: '8種維他命水平：葉酸水平、維他命A水平、維他命B6水平、維他命B12水平、維他命C水平、維他命D及鈣水平、維他命E水平、維他命K1水平',
    Talentgenetesting_thirty_one: '6種微量元素水平：鋅元素水平、鉛元素水平、硒元素水平、銅元素水平、鐵元素水平、鎂元素水平',
    Talentgenetesting_thirty_two: '2種營養需求：奧米伽3需求、抗氧化物需求',
    Talentgenetesting_thirty_three: '10種健康風險：酒精依賴程度、咖啡耐受性、雀斑風險、青春痘風險、高度近視、牙週炎、過敏性鼻炎、易曬黑傾向、乳糖代謝能力、遺傳過敏性濕疹',
    Talentgenetesting_thirty_four: '健身密碼（Fitness Code）– 10項',
    Talentgenetesting_thirty_five: '10種身體特質：爆發力、耐力、骨骼強壯程度、運動損傷風險、肺功能、運動減肥效果、身高、力量訓練的塑形效果、甜味偏好度、飽和脂肪酸對肥胖的影響',
    Talentgenetesting_thirty_six: '權威學術機構科研成果',
    Talentgenetesting_thirty_seven: '哈佛醫學院',
    Talentgenetesting_thirty_eight: '身高',
    Talentgenetesting_thirty_nine: '耶魯大學',
    Talentgenetesting_fourty: '爆發力',
    Talentgenetesting_fourty_one: '牛津大學',
    Talentgenetesting_fourty_two: '語音記憶力',
    Talentgenetesting_fourty_three: '倫敦國王大學',
    Talentgenetesting_fourty_four: '數學天賦',
    Talentgenetesting_fourty_five: '加州大學洛杉磯',
    Talentgenetesting_fourty_six: '堅持力',
    Talentgenetesting_fourty_seven: '倫敦大學學院',
    Talentgenetesting_fourty_eight: '領導力',
    Talentgenetesting_fourty_nine: '針對性培育小孩',
    Talentgenetesting_fifty: 'genecode天賦基因檢測幫助你從天賦、智商、情商、營養及運動等五大方面剖析基因是如何影響你的潛能和特質。',
    Talentgenetesting_fifty_one: '因材施教',
    Talentgenetesting_fifty_two: '發掘天資潛能，有針對性地培養',
    Talentgenetesting_fifty_three: '情緒管理',
    Talentgenetesting_fifty_four: '掌握性格發展特質，改善親子關係',
    Talentgenetesting_fifty_five: '提高效率',
    Talentgenetesting_fifty_six: '找到適合的學習記憶方式',
    Talentgenetesting_fifty_seven: '保障健康',
    Talentgenetesting_fifty_eight: '認識小朋友的營養代謝需求',
    Talentgenetesting_fifty_nine: '善用時間',
    Talentgenetesting_sixty: '為小朋友制定適宜的運動計劃',
    Talentgenetesting_sixty_one: '口腔採樣',
    Talentgenetesting_sixty_two: '安全無痛',
    Talentgenetesting_sixty_three: '觀看視頻',

    Talentgenetesting_sixty_four: '專家解讀報告',
    Talentgenetesting_sixty_five: '給予合適的跟進建議',
    Talentgenetesting_sixty_six: '印有寶寶照片',
    Talentgenetesting_sixty_seven: '送給孩子最好的禮物',
    Talentgenetesting_sixty_eight: '家長心聲',
    Talentgenetesting_sixty_nine: '適用人群',
    Talentgenetesting_seventy: '0-12歲兒童',
    Talentgenetesting_seventy_one: '關注營養、飲食與健康的人士',
    Talentgenetesting_seventy_two: '運動健身愛好者',
    Talentgenetesting_seventy_three: '有家族遺傳疾病風險的人士',
    Talentgenetesting_seventy_four: 'genecode與他們的故事',
    Talentgenetesting_seventy_five: '4歲語言小達人',
    Talentgenetesting_seventy_six: 'June是一個十分活潑好動的小女孩，面對全新的社交環境也從不懼怕。3歲時，June隨同身為律師的父母搬來香港居住，從未接觸過廣東話的她，3個月就已經可以對答自如。父母對她的語言天賦很好奇，接受了genecode基因測試後發現，June的確具備很強的語言天賦。但值得注意的是，June的注意力及堅持力就相對較差，因此父母應該著重培養她的專一性，以獲得更好的發展。',
    Talentgenetesting_seventy_seven: 'June的故事',
    Talentgenetesting_seventy_eight: '3歲運動小健將',
    Talentgenetesting_seventy_nine: '在完成genecode天資密碼測試後，發現活潑的Charlotte在運動方面果然很有天份，只是運動有很多種類，而Charlotte只有3歲，未能自行選擇自己喜愛的運動。於是父母隨即再讓Charlotte進行genecode健身和營養與健康密碼測試。報告指出Charlotte的肺功能和耐力優異，適合長跑游泳等。但需要注意Charlotte有易曬黑傾向，需要做足防曬保護皮膚。',
    Talentgenetesting_eighty: 'Charlotte的故事',
    Talentgenetesting_eighty_one: '8歲閱讀小能人',
    Talentgenetesting_eighty_two: 'Jacob性格內向，不太喜愛說話。最令爸媽擔心的問題是Jacob記憶力好像比同齡的小朋友弱，經常忘記爸媽或老師交待的事情。Jacob媽媽希望透過genecode了解多一些孩子性格和記憶，但結果卻令Jacob媽媽震驚。原來Jacob不屬於內向性格，並且擁有很高的閱讀天賦。只是Jacob的語音記憶力的確比較弱，所以才會記不住爸媽的囑咐而且不太喜愛說話。',
    Talentgenetesting_eighty_three: 'Jacob的故事',
    Talentgenetesting_eighty_four: '常見問題',
    Talentgenetesting_eighty_five: '怎樣透過基因測出寶寶天賦？',
    Talentgenetesting_eighty_six: '天賦基因怎樣做？過程安全嗎？',
    Talentgenetesting_eighty_seven: '天賦基因準確嗎？為甚麼有報導說不可信？',
    Talentgenetesting_eighty_eight: '先天遺傳和後天培養有什麼關係？',
    Talentgenetesting_eighty_nine: '基因檢測怎樣幫助家長培養子女？',
    Talentgenetesting_ninety: '參考文獻',

  },

  YChromosomeDNATest: {
    Title: "Y-染色體母血篩選",
    // P1Title: "孕早期獲知胎兒性别",
    P1Title: "孕早期進行Y染色體母血測試",
    P1Detail: "提早干預遺傳性疾病",

    P2Title: "胎兒DNA存在於母血之中",
    P2Detail: "懷孕時，胎兒的細胞游離DNA會經由胎盤循環至母親的血液。",
    P2Detail2: "當懷孕至6-7週時，母親血液中的胎兒細胞游離DNA量已經足以識別Y染色體的存在。",

    // P3Title: "性染色體 XY = 男",
    // P3Title2: "性染色體 XX = 女",
    P3Title: "",
    P3Title2: "",

    P4Title: "什麼是X連鎖隱形遺傳病？",
    // P4Detail: "孕早期獲知胎兒性別可以幫助有",
    // P4Detail_2: "遺傳疾病困擾",
    // P4Detail_3: "的家庭提早進行干預。",
    // P4Detail2: "譬如，X連鎖隱性遺傳病是非常嚴重的遺傳疾病（如",
    P4Detail: "",
    P4Detail_2: "",
    P4Detail_3: "",
    P4Detail2: "X連鎖隱性遺傳病是非常嚴重的遺傳疾病（如",
    P4Detail2_2: "脆性X綜合症",
    P4Detail2_3: "），主要會影響男寶寶健康。如果媽媽是X連鎖隱性遺傳病的攜帶者，如果她的後代是兒子，則有50%的機會患病。",
    // P4Detail3: "因此，進行詳細的產前遺傳咨詢，提前了解胎兒性別十分必要。",
    P4Detail3: "因此，進行詳細的產前遺傳咨詢，十分必要。",

    P5Title: "如何進行檢測？",
    P5Detail: "從媽媽的血液樣本中分離出胎兒游離DNA",
    P5Detail2: "使用特異的引物（primer）去識別其中的Y染色體DNA",
    P5Detail3: "如果存在Y染色體，則目標序列將在引物的指導下擴增並發出熒光，直至被探測到",


    P6Title: "檢測方案",
    P6Row1Col1: "檢測名稱",P6Row1Col2: "檢測工作日",P6Row1Col3: "檢測樣本",
    P6Row2Col1: "7週或以上母血篩選測試",P6Row2Col2: "1個工作日",P6Row2Col3: "6mL EDTA母血x2",
    P6Row3Col1: "7週或以上母血篩選測試（加急）",P6Row3Col2: "6個小时",P6Row3Col3: "6mL EDTA母血x2",
    P6Row4Col1: "6週或以上母血篩選測試",P6Row4Col2: "1個工作日",P6Row4Col3: "6mL EDTA母血x2",
    P6Row5Col1: "6週或以上母血篩選測試（加急）",P6Row5Col2: "6個小时",P6Row5Col3: "6mL EDTA母血x2",

    P7Title: "檢測優勢",
    P7_1Title: "準確",
    P7_1Detail: "準確率高達99.9%",
    P7_2Title: "早知",
    P7_2Detail: "懷孕6週即可檢測",
    P7_3Title: "更快",
    P7_3Detail: "最快6小時出報告",
    P7_4Title: "信心",
    P7_4Detail: "受香港醫務化驗師管理委員會及註冊一級化驗師監管",
    P7_5Title: "技術",
    P7_5Detail: "精準及全自動化DNA檢測技術",
    P7_6Title: "安全",
    P7_6Detail: "無流產風險",

    P8Title: "適用人群",
    P8_1Detail: "懷孕6週或以上的準媽媽",
    P8_2Detail: "有家族遺傳病史（性別相關）的孕婦",

  },
  
   
  NonInvasivePrenatalTest: {
    Title: "無創產前檢測",
    P1Title: "孕婦首選・為BB健康做好準備",
    P1Detail: "關注染色體異常情況・降低遺傳疾病風險",

    P2Title: "您知道染色體疾病嗎?",
    P2Detail: "每個正常人體都擁有23對染色體，其中22對屬於常染色體，另外1對是決定性別的性染色體。",
    P2Detail2: "當染色體的數目或結構發生異常，如某對染色體不是正常的2條，而變成3條時，就會導致染色體疾病。",
    P2Detail3: "染色體疾病絕大多數發生於受精卵形成時，屬於隨機突變。因此，",
    P2Detail3_2: "每對父母都有可能誕下患有染色體疾病的小朋友。",
    P2Detail4: "而現今的醫學並沒有方法治愈，所以選擇安全、快速、準確的產前檢測，可讓準爸媽安心等待BB到來。",

    P3Title: "當染色體發生異常，BB可能出現以下症狀︰",
    P3_1Title: "智力障礙",
    P3_2Title: "自閉",
    P3_3Title: "發育遲緩",
    P3_4Title: "畸形",
    P3_5Title: "先天性心臟病",

    P4PreTitle: "新生BB前奏曲",
    P4Title: "無創產前檢測",
    P4Detail: "為下一代的健康努力不懈，給準媽媽最強大的支持",

    P5Title: "什麼是無創產前檢測?",
    P5Detail: "無創產前檢測是一項安全、簡單、非侵入性的產前檢測，能夠在懷孕9週起對特定染色體疾病進行篩查。",
    P5Detail2: "孕婦在懷孕期間，胎兒的游離DNA會經過胎盤進入母體的血液系統。無創產前檢測只需抽取孕婦靜脈血，通過第二代基因測序技術，即可篩查胎兒染色體異常狀況。",


    P6Title: "無創產前檢測比較",
    P6Detail: "相對於傳統侵入性產前診斷方法（羊膜穿刺等），無創產前基因檢測是非常安全的產前檢測方式，不會導致流產和羊膜腔感染，更大程度降低孕婦產前檢測的恐懼感，提高孕婦接受產前染色體異常篩查的意願。",
    P6Row1Col1: "",P6Row1Col2: "無創產前檢測",P6Row1Col3: "早孕期篩選",P6Row1Col4: "中孕期篩選",P6Row1Col5: "羊膜穿刺",
    P6Row2Col1: "懷孕週數",P6Row2Col2: "9週或以上",P6Row2Col3: "11-13週",P6Row2Col4: "16-19週",P6Row2Col5: "16-20週",
    P6Row3Col1: "方法",P6Row3Col2: "分析來自胎盤代表胎兒的游離DNA",P6Row3Col3: "超聲波量度胎兒頸皮母血驗PAPP-A，hCG",P6Row3Col4: "母血驗AFP，hCG，uE3及Inhibin A",P6Row3Col5: "胎兒染色體分析",
    P6Row4Col1: "檢出率",P6Row4Col2: "99%以上",P6Row4Col3: "80-90%",P6Row4Col4: "80%",P6Row4Col5: "99%以上",
    P6Row5Col1: "檢測方式",P6Row5Col2: "非侵入性檢測（抽母血，無流產或感染風險）",P6Row5Col3: "非侵入性檢測（抽母血，無流產或感染風險）",P6Row5Col4: "非侵入性檢測（抽母血，無流產或感染風險）",P6Row5Col5: "侵入性檢測（抽羊水，有0.5%-1%流產或感染風險）",
    P6Row6Col1: "報告週期",P6Row6Col2: "最快3個工作日",P6Row6Col3: "1-2個工作日",P6Row6Col4: "1-2個工作日",P6Row6Col5: "14-21個工作日",


    P7Title: "適用人群",
    P7_1Detail: "懷孕9週或以上",
    P7_2Detail: "不願意承擔侵入性檢測帶來的流產風險",
    P7_3Detail: "唐氏綜合症篩查結果為高風險",
    P7_4Detail: "多次流產／",
    P7_4Details:"懷有試管嬰兒",
    P7_5Detail: "有染色體異常懷孕史",

    P8Title: "檢測優勢",
    P8_1Title: "安全無創",
    P8_1Detail: "無流產風險",
    P8_2Title: "快捷簡易",
    P8_2Detail: "只需孕婦靜脈血，約3-7個工作日出報告",
    P8_3Title: "信心保證",
    P8_3Detail: "香港註冊醫療化驗師簽發報告",
    P8_4Title: "早孕檢測",
    P8_4Detail: "懷孕9週起即可檢測（包括雙胞胎）",
    P8_5Title: "全面篩查",
    P8_5Detail: "常染色體三倍體綜合症性染色體異常綜合症微缺失及微重複綜合症",

    P9Title: "常見問題",
    P9_1Title: "年齡未滿35歲的孕婦也適合做無創產前檢測嗎？",
    P9_1Detail: "適合。無創產前檢測內容包括常染色體三倍體綜合症，性染色體異常綜合症，及微缺失及微重複綜合症。",
    P9_1Detail2: "雖然常染色體三倍體綜合症中的唐氏綜合症多發於35歲以上的孕婦，但微缺失及微重複綜合症與唐氏綜合症不同，其發病率不隨年紀而增長，任何年紀都有可能患病。因此，即使年齡未滿35歲的孕婦都有篩查的必要。",
    P9_2Title: "無創產前檢測結果為低風險，是否就意味著無需羊膜穿刺？",
    P9_2Detail: "否。雖然創產前檢測具很高的準確性，但結果不用作最終診斷，僅作為高準確性的篩查手段。目前，染色體核型分析依然是產前診斷的金標準。",
    P9_2Detail2: "因此，檢測結果為低風險者，也不能完全排除胎兒患病的可能性，是否需要羊膜穿刺應遵從醫生指示。",
  },
  NonInvasivePrenatalPaternityTest: {
    Title: "無創產前親子鑑定",
    P1Title: "BB還未出生可做親子鑑定嗎？",
    P1Detail: "可以的！",

    P2Title: "什麼是無創產前親子鑑定？",
    P2Detail: "無創產前親子鑑定是將母親血液中提取的胎兒游離DNA，同疑父樣本中提取到的DNA進行測序及SNP分型配對，進而分析親子關係的檢測技術。",
    P2Detail2: "由於母血中胎兒游離DNA是片段化的，傳統技術很難獲取足夠有效的位點進行親子關係判定。而新型SNP分型技術可以應用於小片段DNA，並且對整個人類基因組上大量的SNPs進行分析，結果更準確。",

    P3Title: "檢測優勢",
    P3_1Title: "安全",
    P3_1Detail: "抽母血即可",
    P3_1DetailHeavy: "無流產風險",
    P3_2Title: "簡單",
    P3_2Detail: "只需 10mL 孕婦靜脈血",
    P3_2DetailHeavy: "無需抽羊水或採集絨毛",
    P3_3Title: "早知",
    P3_3Detail: "或以上即可檢測",
    P3_3DetailHeavy: "懷孕7週",
    P3_4Title: "準確",
    P3_4Detail: "準確率",
    P3_4DetailHeavy: "超過99.999999%",
    P3_5Title: "快速",
    P3_5Detail: "可知結果",
    P3_5DetailHeavy: "最快5日",
    P3_6Title: "私隱",
    P3_6Detail: "不透露客戶任何個人信息",
    P3_6DetailHeavy: "絕對保密",

    P4Title: "接受的鑑定樣本",
    P4_1Title: "孕婦",
    P4_1Detail: "靜脈血",
    P4_2Title: "疑父",
    P4_2Detail: "靜脈血、口腔拭子、指甲、血斑、精斑、5-10根帶毛囊的頭髮",
    P4_2Detail2: "（選其一，建議選擇靜脈血或口腔拭子）",

    P5Title: "適用人群",
    P5_1Detail: "想確認或尋找胎兒生父的孕婦",
    P5_2Detail: "想確認胎兒是否和自己有親子關係的男士",
    P5_3Detail: "不願意入侵性採樣的孕婦",
    P5_4Detail: "不適宜接受入侵性採樣的孕婦，如羊水過少等",
  },

  vaccinetest: {
    vaccinetest_one: '了解疫苗保護性・免受傳染病感染',
    vaccinetest_two: '疫苗並非終身有效・一旦感染可以致命',
    vaccinetest_three: '什麼是疫苗？什麼是抗體？',
    vaccinetest_four: '疫苗是整個病原體或部份病原體，透過不活化或減輕毒性的過程，加入安定劑、佐劑製造而成。從免疫學的觀點來看，所謂疫苗接種，就是將疫苗製劑接種到人體內，藉由免疫系統對外來物的辨認，進行抗體的篩選和製造，以產生對抗該病原體或相似病原體的抗體，使人體獲得抵抗某一特定或與疫苗相似病原的免疫力。',
    vaccinetest_five: '注射疫苗並不意味終身保護，主要原因為：',
    vaccinetest_six: '1. 疫苗保護率',
    vaccinetest_seven: '「疫苗保護率97%」不是指1人享有97%的保護，而是100人裡有3人會有生病的可能！',
    vaccinetest_eight: '2. 保護期效',
    vaccinetest_nine: '抗體存在保護期效，大部分疫苗都並非保障終身！',
    vaccinetest_ten: '3. 生產質量',
    vaccinetest_eleven: '疫苗生產質量不合格，存放及運輸溫度不適宜都會造成疫苗無效！',
    vaccinetest_twelve: '4. 接種人士',
    vaccinetest_threeteen: '接種人士體質不同，無法激發免疫系統從而造成抗體不足！',
    vaccinetest_fourteen: '檢測內容',

    vaccinetest_fiveteen: '甲型肝炎抗體',
    vaccinetest_sixteen: '乙肝病毒表面抗體（定量）',
    vaccinetest_seventeen: '麻疹抗體 IgG',
    vaccinetest_eighteen: '流行性腮腺炎抗體 IgG',
    vaccinetest_nineteen: '德國麻疹病毒抗體 IgG',
    vaccinetest_twenty: '水痘帶狀疱疹抗體 IgG',
    vaccinetest_twenty_one: '破傷風類毒素抗體 IgG',
    vaccinetest_twenty_two: '白喉類毒素抗體 IgG',
    vaccinetest_twenty_three: '小兒麻痹病毒抗體',
    vaccinetest_twenty_four: '乙型流感嗜血桿菌抗體 IgG',
    vaccinetest_twenty_five: '肺炎鏈球菌抗體 IgG',
    vaccinetest_twenty_six: '狂犬病毒抗體',
    vaccinetest_twenty_seven: '檢測套餐',
    vaccinetest_twenty_eight: '適用人群',
    vaccinetest_twenty_nine: '兒童（3歲或以上）',
    vaccinetest_thirty: '育齡及懷孕初期夫婦',
    vaccinetest_thirty_one: '很久之前打過或不確定是否打過疫苗人士',
    vaccinetest_thirty_two: '免疫功能不全的患者',
    vaccinetest_thirty_three: '即將前往傳染病爆發高危地區的旅客',
    vaccinetest_thirty_four: '香港家庭計劃指導會建議：',
    vaccinetest_thirty_five: '懷孕前德國麻疹抗體檢測若是陰性，應注射疫苗，避免傳染給胎兒，導致胎兒先天性畸形。建議注射疫苗后3個月再開始備孕。',
    vaccinetest_thirty_six: '常見問題',
    vaccinetest_thirty_seven: '曾經接受過疫苗接種，抗體檢測結果成陰性應該如何處理？',
    vaccinetest_thirty_eight: '不同疫苗的保護率及保護期效有所不同，即使曾經接受過疫苗接種，都可能因為時間過長或自身免疫力差異而失去保護作用。抗體檢測結果為陰性者是否需要注射加強針，應該結合疫苗接種史，遵醫囑加以考慮。',
    vaccinetest_thirty_nine: '參考文獻',

  },


  stdfastces: {
    stdfastces_one: '在家自我檢測性傳播疾病',
    stdfastces_two: '定期檢查．安心放心',
    stdfastces_three: 'staysafe® 安心驗四合一性病快速測試',
    stdfastces_four: '篩查四種常見病原體感染',
    stdfastces_five: '愛滋病',
    stdfastces_six: '乙型肝炎',
    stdfastces_seven: '梅毒',
    stdfastces_eight: '陰部疱疹',
    stdfastces_nine: '定期自檢，給自己和伴侶一份安心',
    stdfastces_ten: '方便易用',
    stdfastces_eleven: '只需幾滴血',
    stdfastces_twelve: '私隱保障',
    stdfastces_threeteen: '在家檢測 ‧ 免除尷尬',
    stdfastces_fourteen: '快速準確',
    stdfastces_fiveteen: '15分鐘 ‧ 即知結果',
    stdfastces_sixteen: '如何檢測？',
    stdfastces_seventeen: '1. 使用微創採血針，擠出少量指尖血',
    stdfastces_eighteen: '2. 用移液管將血液滴到樣本孔',
    stdfastces_nineteen: '3. 待15分鐘檢視結果',
    stdfastces_twenty: '了解更多',


  },
  news: {
    holiday: '假期安排',
    specialNotice: '特別通知',
  },
  monogenicdisease: {
    monogenicdisease_1: '別讓疾病基因遺傳給BB',
    monogenicdisease_2: '婚前或備孕夫婦雙方均應檢測・攜手預見未來',
    monogenicdisease_3: '什麽是單基因遺傳病？',
    monogenicdisease_4: '單基因遺傳病是由單一基因出現異常所導致的疾病。父母將某個基因缺陷傳給孩子會導致單基因遺傳病。',
    monogenicdisease_5: '世界衛生組織（WHO）官方顯示， 全球已有超過10,000種單基因遺傳病',
    monogenicdisease_6: '單基因遺傳病的綜合發病率高達1/100，多數會導致患者死亡、畸形及殘障',
    monogenicdisease_7: '只有5%的疾病可透過藥物治療維持生命，但終生治療費用昂貴，生活質量受到嚴重影響',
    monogenicdisease_8: '隱性單基因遺傳病可出現在沒有家族史的家庭中。',
    monogenicdisease_9: '常見遺傳病症狀',
    monogenicdisease_10: '智力障礙',
    monogenicdisease_11: '發育遲緩',
    monogenicdisease_12: '肌肉萎縮',
    monogenicdisease_13: '器官衰竭',
    monogenicdisease_14: '特殊樣貌',
    monogenicdisease_15: '嚴重貧血',
    monogenicdisease_16: '死亡',
    monogenicdisease_17: '隱性遺傳病 = 沉默殺手',
    monogenicdisease_18: '常染色體隱性遺傳',
    monogenicdisease_19: '父母均為攜帶者，後代有25%機會成為患者',
    monogenicdisease_20: '性染色體隱性遺傳',
    monogenicdisease_21: '母親為攜帶者，兒子有50%機會成為患者',
    monogenicdisease_22: '美國婦產科醫學會指引',
    monogenicdisease_23: '所有孕婦都應該進行單基因遺傳病攜帶篩查',
    monogenicdisease_24: '基本篩查：12種常見單基因隱性遺傳病',
    monogenicdisease_25: '常染色體隱性遺傳',
    monogenicdisease_26: 'α-地中海貧血 (HBA1, HBA2)',
    monogenicdisease_27: '攜帶率︰1/10 (中國南方)',
    monogenicdisease_28: '症狀︰貧血，需定期輸血，嚴重死亡',
    monogenicdisease_29: 'β-地中海貧血 (HBB)',
    monogenicdisease_30: '攜帶率︰1/36 (中國南方)',
    monogenicdisease_31: '症狀︰貧血，需定期輸血，嚴重死亡',
    monogenicdisease_32: '苯丙酮尿症 (PAH)',
    monogenicdisease_33: '攜帶率︰1/35',
    monogenicdisease_34: '症狀︰智力低下，癲癇，行為異常等',
    monogenicdisease_35: '半乳糖血症 (GALT)',
    monogenicdisease_36: '攜帶率︰未知',
    monogenicdisease_37: '症狀︰發育及智能障礙，白內障， 肝硬化，嚴重死亡',
    monogenicdisease_38: '肝豆狀核變性症 (ATP7B)',
    monogenicdisease_39: '攜帶率︰1/50',
    monogenicdisease_40: '症狀︰肝細胞損害，腦退行性病變， 腎臟損傷等',
    monogenicdisease_41: '糖原累積病Ⅱ型 (GAA)',
    monogenicdisease_42: '攜帶率︰1/112',
    monogenicdisease_43: '症狀︰多組織器官損害，以心，肝， 骨骼肌損害為主',
    monogenicdisease_44: '脊髓性肌肉萎縮症 (SMN1)',
    monogenicdisease_45: '攜帶率︰1/62',
    monogenicdisease_46: '症狀︰肌肉逐漸軟弱無力，萎縮',
    monogenicdisease_47: '遺傳性耳聾 (GJB2, SLC26A4)',
    monogenicdisease_48: '攜帶率︰1/29 (GJB2)，1/59 (SLC26A4)',
    monogenicdisease_49: '症狀︰聽力缺失，失聰',
    monogenicdisease_50: '囊狀纖維化 (CFTR)',
    monogenicdisease_51: '攜帶率︰未知',
    monogenicdisease_52: '症狀︰胰腺功能障礙，肺部疾病',
    monogenicdisease_53: 'X染色體隱性遺傳',
    monogenicdisease_54: '脆性X綜合症 (FMR1)',
    monogenicdisease_55: '攜帶率︰1/250-1/1000 (女性)',
    monogenicdisease_56: '症狀︰智力遲緩，自閉症',
    monogenicdisease_57: '乙型血友病 (F9)',
    monogenicdisease_58: '攜帶率︰未知',
    monogenicdisease_59: '症狀︰多部位出血，關節畸形等',
    monogenicdisease_60: '假肥大性肌營養不良 (DMD)',
    monogenicdisease_61: '攜帶率︰未知',
    monogenicdisease_62: '症狀︰步態異常，智力低下',
    monogenicdisease_63: '全面篩查：101種單基因隱性遺傳病',
    monogenicdisease_64: '收起',
    monogenicdisease_65: '適用人群',
    monogenicdisease_66: '育齡及懷孕初期夫婦',
    monogenicdisease_67: '有家族疾病史的育齡夫婦',
    monogenicdisease_68: '血緣關係相近的夫婦',
    monogenicdisease_69: '準備人工輔助生殖的夫婦',
    monogenicdisease_70: '案例分析',
    monogenicdisease_71: '個案：中國廣東籍女性，孕10週，不明原因流產史。 ',
    monogenicdisease_72: '經醫生建議，夫婦雙方進行了地中海貧血基因檢測。',
    monogenicdisease_s: '雙方均為地中海貧血攜帶者。',

    monogenicdisease_73: '結果顯示，',
    monogenicdisease_74: '張太太在孕18週時抽取羊水進行胎兒地中海貧血基因檢測，結果為（--SEA/αα βN/βN），但非重型地中海貧血患者，可繼續妊娠。',
    monogenicdisease_75: '檢測結果有何幫助？',
    monogenicdisease_76: '陰性',
    monogenicdisease_77: '可以正常進行生育',
    monogenicdisease_78: '陽性 ',
    monogenicdisease_79: '建議接受遺傳咨詢，調整生育計劃或選擇人工受孕',
    monogenicdisease_80: '參考文獻',
  },
  Paternitytesting: {
    paternitytesting_1: '安心驗證親緣關係',
    paternitytesting_2: '個人隱私絕對保密',
    paternitytesting_3: '什麼是親子鑑定？',
    paternitytesting_4: '親子鑑定是通過比對子女和父母的DNA，進而判定親子關係的檢測技術。',
    paternitytesting_5: 'DNA又稱遺傳“指紋”，可組成一個人的基因和染色體。每個人的DNA都是獨一無二的，一半來自爸爸，一半來自媽媽。因此，通過比對父母和小朋友的DNA就可以驗證親子關係。',
    paternitytesting_6: '親子鑑定的準確率有多少？',
    paternitytesting_7: '親子鑑定採用短串聯重複序列（Short Tandem Repeat，STR）分析技術，通過對比親代與子代DNA上特異的位點，計算CPI（Combined Paternity Index）指數，從而判斷親子關係，',
    paternitytesting_s: '準確率可達99.999999%。',
    paternitytesting_8: '可鑑定的關係',
    paternitytesting_9: '父子／父女',
    paternitytesting_10: '母子／母女',
    paternitytesting_11: '兄弟姊妹',
    paternitytesting_12: '（全同胞）',
    paternitytesting_13: '叔侄',
    paternitytesting_14: '接受的樣本？',
    paternitytesting_15: '血液',
    paternitytesting_16: '口腔拭子',
    paternitytesting_17: '指甲',
    paternitytesting_18: '血斑／精斑',
    paternitytesting_19: '帶毛囊的頭髮5-10根',
    paternitytesting_20: '檢測工作日',
    paternitytesting_21: '3-5個工作日',
    paternitytesting_22: '常見問題',
    paternitytesting_23: '親子鑑定報告是否保密？',
    paternitytesting_24: '是的，顧客提供的個人資料絕對保密。除非受測者書面同意，親子鑑定結果絕不向受測者以外的第三者披露。',
    paternitytesting_25: '親子鑑定測試的準確度有多高？',
    paternitytesting_26: '若符合親子關係，準確度高達99.99%以上; 當結果是排除親子關係時，則至少會出現兩個以上之點位不吻合，而否定親子關係時準確度是100%。',
    paternitytesting_27: '私人用途和法律用途的親子鑑定有甚麼不同？',
    paternitytesting_28: '準確度無分別。私人用途的報告不能作為法律文件；法律用途的報告可作為各種正式用途，採集樣本時，須有第三者在場作證並記錄。',
  },
  others: {
    others_1: '為BB買衫買鞋，',
    others_2: '更要給他買不到的健康',
    others_3: '計劃BB的出現',
    others_4: '你和伴侶戒掉了咖啡，戒掉了煙酒，調整身體，準備迎接新的生命。',
    others_5: '親朋好友為你們慶祝，買了BB衫褲、BB金首飾，大家期待著，他有個完美的人生開場。',
    others_6: '但還有一樣東西，你是否遺漏了?',
    others_7: '就是要給BB買不到的健康！',
    others_8: 'BB患病是因為你的疏忽嗎？',
    others_9: '表面健康的你，可能帶給寶貝的疾病風險很多：錯過孕前基因篩查、高齡懷孕、攜帶隱性遺傳病基因⋯⋯',
    others_10: '不想留下遺憾?',
    others_11: '就讓我們帶你一起，為BB的健康做足準備吧！',
    others_12: '不論男寶寶還是女寶寶，都是你的心肝寶貝。',
    others_13: '不用等照超聲波，越早檢測，更多時間為寶寶到來做好準備。',
    others_14: '關注胎兒染色體情況，降低染色體異常風險，',
    others_15: '包括唐氏綜合症(T21)、愛德華氏綜合症(T18)、巴陶氏綜合症(T13)等。',
    others_16: '親子鑑定不一定要寶寶出生才可做，只需抽取母血，無流產風險，',
    others_17: '結果同樣準確，為你節省等待的煩惱。',
    others_18: '不論親子或兄弟姐妹，親子鑑定都可助你確定血濃於水的關係。',
    others_19: '接受多種樣本，私隱度高，安全準確。',
    others_20: '關注100+種單基因遺傳病攜帶情況，',
    others_21: '降低下一代死亡、畸形或殘障的可能性。',
    others_22: '再早一點，',
    others_23: '生命就再多一點可能性',
    others_24: '三十而立，',
    others_25: '你對未來有許多期待',
    others_26: '組建自己的家庭——溫柔的伴侶、稚氣的孩子、調皮的寵物。',
    others_27: '你一定想要更多：想看孩子牙牙學語，想參加他的畢業禮；想和愛人慢慢變老，一起散步⋯⋯',
    others_28: '但總有一些隱憂，像藏匿的洪水猛獸，比如癌症。',
    others_29: '早一點行動，',
    others_30: '人生就多一點可能性',
    others_31: '及早篩查癌症風險，及時規避風險、跟進治療；及早監控癌症復發，避免癌症帶來的二次傷害。',
    others_32: '不願讓癌症的威脅破壞你的想象？',
    others_33: '你可以做的，其實有很多！',
    others_34: '關注18種癌症，79種癌症基因，',
    others_35: '提示癌症的遺傳風險，預防勝於治療。',
    others_36: '以嶄新ctDNA技術，隨時掌握腫瘤動向，',
    others_37: '提早偵測復發，預後更佳。',
    others_38: '保護自己，',
    others_39: '也要保護你愛的人',
    others_40: '你很小心對待BB的身體，',
    others_40s:'想給他最全的保護',
    others_41: 'BB降生以來，帶他打疫苗，你從不疏忽，',
    others_42: '但疫苗其實並非終身有效，你又知道嗎？',
    others_43: '了解疫苗保護性，免受傳染病感染。',
    others_44: '你能做到最浪漫的事，',
    others_44s:'就是和愛人一起保持健康',
    others_45: '和愛人溫馨之前，你或許有過各種浪漫幻想⋯⋯',
    others_46: '但除了擔心意外懷孕，你可能也擔心感染性病！',
    others_47: '在美夢開始之前，或許一份檢測可以保護你和伴侶。',
    others_48: '疫苗並非終身有效，一旦感染可以致命，',
    others_49: '檢測12種疫苗抗體，了解免疫情況。',
    others_50: '和伴侶親密接觸也有機會患上性傳染病，會接觸到血液的工作亦要加倍注意！',
    others_51: '為自己為伴侶，請定期檢測。',
    others_52: '了解更多人生故事，',
    others_53: '開啟全新的生活方式',
    others_54: '你記不記得這些瞬間？',
    others_55: '你獲得長跑冠軍的時候，你喝酒千杯不倒的時候，',
    others_56: '你接觸花生而過敏的時候，你為父親的心臟病擔憂的時候。',
    others_57: '其實你的身體已經',
    others_57s:'寫好了這些密碼',
    others_58: '你的基因裡寫著你的天賦密碼，你的身體裡也藏著致敏原的訊號，',
    others_59: '甚至父母和子女的遺傳疾病風險也一一記錄。',
    others_60: '現在，新的生活方式已逐漸盛行，了解更多人生故事，關心你的健康生活。',
    others_61: '關注5大成長因素，70種天賦潛能。',
    others_62: '掌握寶寶天賦潛能，達致因材施教。',


  }
  ,
  use_way:{
  Pravicy:'私隐政策',
  Title:'使用条款',
  },
  Mthfr:{
    Title:'葉酸代謝基因測試',

    P1_Title: "科學補服葉酸，呵護媽媽同BB",
    P1_SubTitle: "你知道需要補葉酸，可是知道補多少嗎？",

    P2_Title: "什麼是葉酸？",
    P2_Content: "葉酸，又名維他命B 9，是一種水溶性維他命。人體自身無法合成，需通過飲食或葉酸補充劑獲得。葉酸和新生兒的神經管發育有很大的關聯，若孕婦在懷孕初期無法提供給胎兒足夠的葉酸，會增加胎兒神經管畸形的機率，且孕婦自身也容易產生貧血等症狀，流產、早產的機率也會增加。",

    P3_Title: "葉酸缺乏的危害",
    P3_Content: "葉酸參與人體的新陳代謝，是合成DNA所必須的元素，也是細胞生長和分裂所必備的物質，更是胚胎發育過程中不可缺少的營養素。因此，對於孕期婦女而言，葉酸的缺乏增加了妊娠期併發症發生的風險、提高了多種不良妊娠結局的發生率。",
    p3_2_Title:"葉酸缺乏可能導致以下風險：",
    P3_2_1_1:"胎兒",
    P3_2_1_2:"神經管畸形、唇裂、先天性心臟病",
    P3_2_2_1:"孕婦",
    P3_2_2_2:"貧血、早產",

    P4_Title: "葉酸過量的危害",
    P4_Content: "葉酸在人體內的吸收和轉化能力是有限的，葉酸過量會導致未代謝的葉酸（Unmetabolised Folic Acid ,UFA）在人體內累積從而對人體造成危害。",
    p4_2_Title:"葉酸過量可能導致以下風險：",
    P4_2_1:"掩蓋維他命B12缺乏的症狀（惡性貧血）",
    P4_2_2:"增加癌症、抑鬱、認知障礙等疾病風險",

    P5_Title: "為什麼要做葉酸代謝基因檢測？",
    P5_Content: "葉酸在人體內必須代謝為5-甲基四氫葉酸才能被有效利用，當MTHFR基因發生突變時，MTHFR酶活性降低，無法有效將葉酸轉化為人體可利用的成分，因此MTHFR基因突變的人需要適當增加葉酸的攝入量。",

    P6_Title: "不同基因型在東亞人群中所佔比例",
    // P6_Content: "數據顯示，在亞洲人群中，突變體和野生型的比例約是0.3 : 0.7。",
    P6_1_1:"基因位點",
    P6_1_2:"MTHFR-C677T",
    P6_1_3:"MTHFR-A1298C",
    P6_2_1:"基因型",
    P6_2_2:"CC（野生型）；CT（突變雜合體）；TT（突變純合體）",
    P6_2_3:"AA（野生型）；AC（突變雜合體）；CC（突變純合體）",

    P7_Title: "檢測內容",
    P7_1_1:"基因",
    P7_1_2:"MTHFR",
    P7_1_3:"MTHFR",
    P7_2_1:"位點",
    P7_2_2:"C677T",
    P7_2_3:"A1298C",
    P7_3_1:"基因功能",
    P7_3_2:"編碼葉酸代謝中的關鍵酶，",
    P7_3_3:"維持正常的同型半胱氨酸水準。",

    P8_Title: "科學補充葉酸",
    P8_Content: "通過檢測MTHFR基因的2個常見突變位點，可以得知MTHFR葉酸代謝酶的活性，從而科學地補充葉酸。",
    P8_1:"測試位點\t基因型\t類型\t酶活性\t葉酸需求",
    P8_2:"MTHFR-C677T\tCC\t野生型\t正常\t正常",
    P8_3:"MTHFR-C677T\tCT\t突變雜合體\t下降\t偏高",
    P8_4:"MTHFR-C677T\tTT\t突變純合體\t下降\t偏高",
    P8_5:"MTHFR-A1298C\tAA\t野生型\t正常\t正常",
    P8_6:"MTHFR-A1298C\tAC\t突變雜合體\t下降\t偏高",
    P8_7:"MTHFR-A1298C\tCC\t突變純合體\t下降\t偏高",
    P8_2_1:"葉酸需求正常",
    P8_2_2:"400微克/天",
    P8_2_3:"葉酸需求偏高",
    P8_2_4:"400-1000微克/天",
    P8_3_1:"備註：",
    P8_3_2:"1. 葉酸可耐受最高攝入量為每日1000微克，超過此攝入量可能會掩蓋維他命B12缺乏的症狀（惡性貧血）。 ",
    P8_3_3:"2. 對於有神經管畸形妊娠史的婦女，必須謹遵醫生建議進行葉酸的補充。",


    P9_Title: "葉酸補充途徑",
    P9_Content: "通過對MTHFR基因及其相關位點的檢測，根據個人情況選擇葉酸補充途徑。",
    P9_Title2: "優勢",
    P9_Title3: "劣勢",
    P9_1_Title:"食物葉酸",
    P9_1_Title2:"",
    P9_1_1:"天然葉酸；",
    P9_1_2:"無耐受上限；",
    P9_1_3:"不易掩蓋VB12缺乏問題。",
    P9_1_4:"不穩定；",
    P9_1_5:"原料經過加工易流失；",
    P9_1_6:"生物利用度低。",
    P9_2_Title:"合成葉酸",
    P9_2_Title2:"",
    P9_2_1:"技術大眾；",
    P9_2_2:"成本低廉；",
    P9_2_3:"較為穩定。",
    P9_2_4:"高劑量會掩蓋VB12缺乏症狀；",
    P9_2_5:"補充過量存在危險；",
    P9_2_6:"生物利用度低。",
    P9_3_Title:"活性葉酸",
    P9_3_Title2:"(L- 5 - M T H F)",
    P9_3_1:"成品穩定；不因未代謝葉酸引起危害；",
    P9_3_1_2:"",
    P9_3_2:"人體可直接吸收利用；生物利用度高；",
    P9_3_3:"不易掩蓋VB12缺乏問題。",
    P9_3_4:"需要专利技术生产；",
    P9_3_5:"价格较高。",

    P10_Title:"適用人群",
    P10_1:"備孕或者懷孕中的婦女",
    P10_2:"曾懷有神經管缺陷胎兒的婦女",
    P10_3:"有習慣性流產、早產、曾懷有畸胎的婦女",
    P10_4:"有家族心臟血管病史的孕婦",
    P10_5:"有貧血病史的孕婦",

    P11_Title:"檢測流程",
    P11_1:"1. 收集樣本",
    P11_2:"2. 核對樣本資料",
    P11_3:"3. 提取受測者DNA",
    P11_4:"4. DNA質檢",
    // P11_5:"5. 使用PCR進行SNP基因分型",
    P11_5:"5. 進行SNP基因分型",
    P11_6:"6. 數據庫自動分析檢測結果",
    P11_7:"7. 化驗師核查檢測結果",
    P11_8:"8. 發送報告",

    P12_1_Title:"樣本要求",
    P12_1_1:"6mL靜脈血",
    P12_2_Title:"檢測週期",
    // P12_2_1:"1個工作日",
    P12_2_1:"5個工作日",

    P13_Title:"參考文獻",
    P13_1:"1.\tDivision of Cancer Epidemiology and Genetics, National Cancer Institute.",
    P13_2:"2.\t《圍受孕期增補葉酸預防神經管缺陷指南(2017)》",
    P13_3:"3.\tGreenberg J A, etc. Reviews in Obstetrics and Gynecology, 2011, 4(2): 52.",
    P13_4:"4.\tScaglione F, etc. Xenobiotica, 2014, 44(5): 480-488.",
    P13_5:"5.\tCenters for Disease Control and Prevention (2020). Retrieving from https://www.cdc.gov/ncbddd/folicacid/mthfr-gene-and-folic-acid.html.",
    P13_6:"6.\tNational Health Commission of the PRC (WS/T 578.5—2018). Chinese dietary reference intakes—Part 5: Water-soluble vitamin. ",
    P13_7:"7.\tWeisberg I, etc. Molecular genetics and metabolism, 1998, 64(3): 169-172.",
    P13_8:"8.\tRS1801133 RefSNP report - dbSNP - NCBI (2018). National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801133.",
    P13_9:"9.\tRS1801131 RefSNP report - dbSNP - NCBI (2018) National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801131.",
    P13_10:"10.\tLiwinski T, Lang UE. Folate and Its Significance in Depressive Disorders and Suicidality: A Comprehensive Narrative Review. Nutrients. 2023;15(17):3859. Published 2023 Sep 4. doi:10.3390/nu15173859.",
    P13_11:"11.\tMorris MC, Evans DA, Bienias JL, et al. Dietary Folate and Vitamin B12 Intake and Cognitive Decline Among Community-Dwelling Older Persons. Arch Neurol. 2005;62(4):641–645. doi:10.1001/archneur.62.4.641.",
    P13_12:"12.\tPieroth R, Paver S, Day S, Lammersfeld C. Folate and Its Impact on Cancer Risk. Curr Nutr Rep. 2018;7(3):70-84. doi:10.1007/s13668-018-0237-y.",
  }

};
export {
  MessageTcc
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tcc.js